import { render, staticRenderFns } from "./MobileDisabled.vue?vue&type=template&id=678d8cf5&scoped=true"
var script = {}
import style0 from "./MobileDisabled.vue?vue&type=style&index=0&id=678d8cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d8cf5",
  null
  
)

export default component.exports